<template>
    <div id="DepartmentManagement" class="page-content">
        <el-breadcrumb separator="/" class="breadcrumb">
            <el-breadcrumb-item>子账号管理</el-breadcrumb-item>
            <el-breadcrumb-item>部门管理</el-breadcrumb-item>
        </el-breadcrumb>
        <section class="content-warpper  content-warpper-main2">
            <div class="header pointer" @click="parentShow=true" style="color: #108cee">
                <i class="el-icon-plus"></i>新增部门
            </div>
            <!--新增-->
            <el-row style="margin: 20px 0;" v-show="parentShow">
                <el-col :span="8">
                    <el-input v-model="parent.departName" placeholder="请输入部门名称" size="small"></el-input>
                </el-col>
                <el-col :span="10" :offset="2">
                    <el-select v-model="parent.leaderCheck" multiple placeholder="请选择负责人" size="small">
                        <el-option
                                v-for="item in parent.Leader"
                                :key="item.id"
                                :value="item.id"
                                :label="item.realname"
                        ></el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <el-button type="confire_btn" @click="addParentDepart" size="small">确定</el-button>
                    <el-button type="cancel_blue" @click="parentShow=false" size="small">取消</el-button>
                </el-col>
            </el-row>
            <el-table
                    :data="tableData"
                    style="width: 100%"
                    row-key="id"
                    :tree-props="{children: 'subSysDepartment'}"
                    ref="multipleTable"
                    :row-class-name="tableRowClassName"
                    :show-header="false"
                    @cell-click="rowClicks"
            >
                <el-table-column
                >
                    <template slot-scope="scope">
                        <span v-show="scope.row.hasDepartment"> {{scope.row.departName}}</span>
                        <el-input v-model="scope.row.departName"  v-show="!scope.row.hasDepartment" size="small" style="width: 245px;"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="name"
                        width="415">
                    <template slot-scope="scope">
                        <span v-show="scope.row.hasDepartment"> 负责人：{{scope.row.departLeader}}</span>
                        <el-select v-model="departLeaderId" multiple  v-show="!scope.row.hasDepartment" size="small">
                            <el-option
                                    v-for="item in Leader"
                                    :key="item.id"
                                    :value="item.id"
                                    :label="item.realname"
                            ></el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column
                >
                    <template slot-scope="scope">
                        <div class="operate" v-show="scope.row.hasDepartment">
                            <span @click="addLowerLevel(scope.row.id,scope.row)"><i class="el-icon-circle-plus-outline"></i>
                                <span class="icon_span">新增下级</span>
                            </span>
                            <span class="span_line" @click="getDepartmentLeaderList(scope.row.id,scope.row.departLeaderId),getIndex(),haveEdit=false"><i class="el-icon-edit-outline" ></i>
                                <span class="icon_span">编辑</span>
                            </span>
                            <span class="span_line" @click="deleteDepartment(scope.row)"><i class="el-icon-delete"></i>
                                <span class="icon_span">删除</span>
                            </span>
                        </div>
                        <div v-show="!scope.row.hasDepartment&&!scope.row.new" class="operate operate_icon">
                            <i class="el-icon-close" @click="fuByIds();scope.row.hasDepartment=true;canEdit=true"></i>
                            <span></span>
                            <span @click="saveInfo(scope.row.id,scope.row.departName);canEdit=true"> <i class="el-icon-check" ></i></span>
                        </div>
                        <div v-show="scope.row.new" class="operate">
                            <span @click="savaDepartmentLevel(scope.row.id,scope.row.departName),canEdit=true">确定</span>
                            <span></span>
                            <span @click="fuByIds(),haveEdit=true,canEdit=true">取消</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </section>
        <!-- 提示-->
        <elementHint ref="hintCommon"   :main="hint.main" @hintConfire="hintConfire" ></elementHint>
    </div>
</template>
<script>
    import elementHint from "../../../components/dataTable/elementHint";//提示
    export default {
        created(){
            this.fuByIds()
        },
        data:function(){
            return{
                hint:{
                  main:''
                },
                parent:{
                  departName:''
                },
                departLeaderId:[],
                parentShow:false,
                tableData: [],
                Leader:[],//负责人
                ifFather:false,//判断点击的是父节点还是子节点
                expandKey:[],//需要展开的行
                // 获取row的key值
                getRowKeys(row) {
                  return row.id;
                },
                haveEdit:true,
                canEdit:true,//是否能编辑
                indexlength:0
            }
        },
        methods:{
            rowClicks(row, column, event){
              if(!this.canEdit&&this.haveEdit){
                this.$refs.multipleTable.toggleRowExpansion(row,true)
                this.haveEdit=false
              } // 点击展开table
            },
            tableRowClassName({row, rowIndex}) {
              //表格颜色
              for(let item of this.tableData){
                  if (rowIndex === item.indexs) {
                      return 'success-row';
                  }
              }
              return '';
            },
            fuByIds(){
              //所在部门
              this.haveEdit=true
              let that=this
              fetch({
                url: "hcm/department/fuByIds",
                method: "get",
                params:{id:0},
              }).then((res)=>{
                if(res.status=='10000'){
                    if(res.data)  this.$set(this,"tableData",res.data);
                    else this.$set(this,"tableData",[])
                    this.removeEle(that.tableData)
                }
              })
            },
            getDepartmentLeaderList(id,departLeader){
              if(!this.canEdit)return false
              if(departLeader){
                departLeader=departLeader.split(',')
                var arr=[]
                for(let item of departLeader){
                    arr.push(Number(item))
                }
                this.departLeaderId=arr
              }
              else this.departLeaderId=[]
              this.departmentId=id
              //负责人
              fetch({
                url: "hcm/userout/getDepartmentLeaderList",
                method: "get",
                params:{departmentId:id},
              }).then((res)=>{
                if(res.status=='10000'){
                    this.Leader=res.data
                }
              })
            },
            getIndex(){
              if(!this.canEdit)return false
              this.forTable(this.tableData)//编辑
            },
            forTable(data){
              //输入框显示隐藏
              for(let item in data){
                if(data[item].id==this.departmentId){
                    //父级(选中的行)
                  data[item].hasDepartment=false//根据hasDepartment进行隐藏显示
                }else{
                  data[item].hasDepartment=true
                }
                if(data[item].subSysDepartment){
                  //有子节点
                  if(data[item].id==this.departmentId){
                      data[item].hasDepartment=false
                  }else{
                      data[item].hasDepartment=true
                  }
                  this.forTable(data[item].subSysDepartment)//递归调用传入子节点
                }else{
                  if(item==data.length) return;//循环结束退出
                }
              }
            },
            saveInfo(id,departName){
              if(departName==''||departName==''){
                this.$message.error("请填写部门名称")
                return false
              }
              let a
              if(this.departLeaderId.length==0)a=''
              else a=this.departLeaderId.join(',')
              let data={id, departName,departLeader:a}
              this.haveEdit=true
              //保存
              fetch({
                url: "hcm/department/savaDepartment",
                method: "post",
                data:data,
              }).then((res)=>{
                if(res.status=='10000'){
                    this.$message.success("成功")
                    this.fuByIds()//初始化
                }else{
                    this.$message.error(res.message)
                }
              })
            },
            hintConfire(){
              //不是父节点
              if( this.hint.confire){
                fetch({
                    url: "hcm/department/deleteDepartment",
                    method: "post",
                    data:{
                        id:this.rowId
                    },
                })
                .then((res)=>{
                    if(res.status=='10000'){
                        this.$refs.hintCommon.closeifsee()
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.fuByIds()//初始化
                    }else{
                        this.$message.error(res.message);
                    }
                })
              }else{
                this.$refs.hintCommon.closeifsee()
              }

            },
            deleteDepartment(row){
              //删除节点
              let info=''
              if(row.subSysDepartment) this.hint.main='您暂时不能删除该部门,原因该部门下存在子级或子账号！'
              else  this.hint.main='你确认要删除该部门嘛？'
              //删除
              if(!row.subSysDepartment){
                  //不是父节点
                  this.$refs.hintCommon.ifsee()
                  this.hint.confire=true
                  this.rowId=row.id
              }else{
                  this.$refs.hintCommon.ifsee()
                  this.hint.confire=false
              }
            },
            addLowerLevel(id,row){
              //新增下级
              if(this.haveEdit){
                  this.departLeaderId=[]
                  this.departmentId=id
                  this.forSubordinate(this.tableData,row)
              }
            },
            savaDepartmentLevel(parentId,departName){
              if(departName==''){
                  this.$message.error("请填写部门名称")
                  return false
              }
              let data={}
              if(departName){
                  data.departName=departName
                  data.parentId=this.departmentId
              }else{
                  data.departName=''
                  data.parentId=parentId
              }
              fetch({
                  url: "hcm/department/savaDepartment",
                  method: "POST",
                  data:data,
              }).then((res)=>{
                if(res.status=='10000'){
                    this.$message.success('成功!');
                    this.fuByIds()
                    this.haveEdit=true
                }else{
                    this.$message.error(res.message);
                }
              })
            },
            forSubordinate(data,row){
                this.canEdit=false
                for(let item of data){
                    if(item.id==this.departmentId){
                        let obj={
                            departName:'',
                            hasDepartment:false,
                            id:Symbol(),
                            new:true
                        }
                        if(item.subSysDepartment){
                            item.subSysDepartment.splice(0,0,obj)
                        }else{
                            let a=[]
                            a.push(obj)
                            item.subSysDepartment=a
                        }
                        this.$set(this,"tableData",this.$refs.multipleTable.data);
                        this.$refs.multipleTable.toggleRowExpansion(row,true) // 点击展开table
                        return
                    }else{
                        if(item.subSysDepartment) this.forSubordinate(item.subSysDepartment,row)
                    }
                }
            },
            removeEle(data){
                for(let item in data){
                    data[item].indexs=this.indexlength
                    ++this.indexlength
                    data[item].hasDepartment=true
                    if(data[item].subSysDepartment){
                        //有子节点
                        data[item].hasDepartment=true
                        this.removeEle(data[item].subSysDepartment)//递归调用传入子节点
                    }else{
                        if(item==data.length){
                            return
                        }//循环结束退出
                    }
                }
            },
            addParentDepart(){
                if(this.parent.departName==''){
                    this.$message.error("请填写部门名称")
                    return false
                }
                fetch({
                    url: "hcm/department/savaDepartment",
                    method: "post",
                    data:{
                        parentId:0,
                        departName:this.parent.departName,
                        departLeader:''
                    },
                }).then((res)=>{
                    if(res.status=='10000'){
                        this.fuByIds()//初始化
                        this.parent={}
                        this.parentShow=false
                        this.$message.success( "成功")
                    }else  this.$message.error(res.message)
                })
            }
        },
        components:{elementHint}
    }
</script>

<style lang="scss">
    #DepartmentManagement{
        .el-table__empty-text{
            padding-top: 100px;
            background: url("../../../assets/img/other/nodata.svg") no-repeat;
            background-position: center 66px;
        }
        .icon_span{
            padding-left: 5px;
        }
        .el-table .success-row {
            background: #f3f7ff;
        }
        .el-table__expand-icon{
            border: 1px solid #d9d9d9;
            width: 14px;
            height: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .el-table__expand-icon{
            .el-icon-arrow-right{
                &:before{
                    content: '+';
                    color: #d9d9d9;
                    font-size: 12px;
                }
            }
        }
        .el-table__expand-icon--expanded{
            transform:rotate(0)
        }
        .el-table__expand-icon{
            margin-top: 4px;
        }
        .el-table__expand-icon--expanded{
            .el-icon-arrow-right{
                &:before{
                    content: '-';
                    color: #d9d9d9;
                    font-size: 20px;
                }
            }
        }
        .el-table .cell{
            display: flex;
        }
        .content-warpper-main-title{
            border-bottom:1px solid #d9d9d9;
            margin-bottom: 0;
            padding: 10px;
        }
        .operate{
            color:#108cee;
            i{
                font-size: 14px;
            }
            span{
                margin-right: 14px;
                cursor: pointer;
            }
            .span_line{
                padding-left:14px;
                border-left: 1px solid #d9d9d9;
            }

        }
        .operate_icon{
            i{
                font-size: 22px;
            }
        }
        .content-warpper-main2{
            margin-top: 0;
            .header{
                width: 100%;
                text-align: center;
                border:1px dashed #d9d9d9;
                padding:5px 0;
                margin-bottom: 20px;
            }
        }
    }
</style>
